import { TechTuningCategory, TechTuningRarity, WalletType } from '~/shared';
import { ColorGradient } from '../ItemColor';

export interface IShopItem {
	id: string;
	name: string;
	category: TechTuningCategory;
	price: number;
	walletType: WalletType;
	isNew: boolean;
	imageBg: ColorGradient;
	boost?: number;
	discount?: number;
	oldPrice?: number;
}

export const getColorOrder = (color: TechTuningRarity): number => {
	switch (color) {
		case TechTuningRarity.COMMON:
			return 1;
		case TechTuningRarity.UNCOMMON:
			return 2;
		case TechTuningRarity.RARE:
			return 3;
		case TechTuningRarity.EPIC:
			return 4;
		case TechTuningRarity.LEGENDARY:
			return 5;
		default:
			return 999;
	}
};
